export default {
  general: {
    name: "Flow Simulation Game",
    yes: "Ja",
    no: "Nein",
    previous: "Zurück",
    next: "Weiter",
    ok: "OK",
    confirmation: "Bestätigen",
    week: "Woche",
    units: "{nbr} Stück | {nbr} Stück | {nbr} Stücke",
    smallWeek: "W",
    timerMessage: "Sie haben das Zeitlimit überschritten, bitte entscheiden Sie so schnell wie möglich!",
    wrongValue: "Falscher Wert",
    gameFinished: "Das Spiel ist beendet",
    gamePaused: "Das Spiel ist pausiert",
    required: "Erforderlich",
    stockFrom: "Bestand von",
    assemblyStock: "Gesamtbestand",
    testMode: "Dieses Spiel ist im Test-Modus. Es kann nicht kommerziell genutzt werden."
  },
  
  instructions: {
    chooseAvatar: "Wählen Sie Ihren Avatar",
    title: "Anleitung",
    step: "Schritt",
    ready: "Ich bin bereit für das Spiel",
    wait: "Bitte warten Sie, bis die anderen Speieler bereit sind",
    start: "Spiel beginnen"
  },

  steps: {
    bufferSetup: "Einstellungen des Puffers",
    clientOrder: "Kundenaufträge",
    clientShipment: "Kundenlieferungen",
    supplierShimpentWaiting: "Warte auf Nachschub",
    board: "Kennzahlen",
    supplierShipments: "Nachschub",
    supplierOrders: "Lieferantenaufträge",
    productionBatch: "Fertigungsstart",
    productionShipments: "Nachschub aus Fertigung",
    startNewWeek: "Eine neue Woche beginnen",
    youCanStartNewWeek: "Sie können eine neue Woche beginnen",
    inProgressProduction: "Umlaufbestand in Fertigung",
    flowEquationCalc: "Net-Flow-Gleichung",
    clientOrderTitleMessage: "Sie haben einen Kundenauftrag erhalten"
  },

  clientsShimpents: {
    chooseQuantity: "Bitte geben Sie Ihre Lieferungen an",
    notMax: "Bitte liefern Sie so gut es geht",
    remains: "Kundenaufträge (überfällig & heute fällig): ",
    ok : "Lieferung bestätigen",
    shipmentsResume: "Sie haben {nbr} Stück an Ihre Kunden geliefert | Sie haben {nbr} Stück an Ihre Kunden geliefert",
    remainResume: "Sie sind mit {nbr} Stück im Rückstand | Sie sind mit {nbr} Stück im Rückstand"
  },

  board: {
    cantOrder: "Sie können derzeit nicht bestellen",
    cantProduce: "Sie können derzeit keinen Fertigungsauftrag erteilen"
  },

  suppliersShipments: {
    shipments: "Lieferung von",
    production: "Sie haben {nbr} Stück gefertigt | Sie haben {nbr} Stück gefertigt",
    getShipments: "Vereinnahmen",
    waitShipment: "Bitte warten Sie auf Lieferungen",
    stockChange: "Ihr Bestand beträgt nun {nbr} Stück | Ihr Bestand beträgt nun {nbr} Stück",
    stockChangeTitle: "Aktualisieren Sie Ihren Bestand"
  },

  suppliersOrders: {
    maxOrder: "Höchste Bestellmenge ",
    ordersTo: "Bestellung an",
    remainsAlert: "Zur Erinnerung: Sie haben nicht alle Kundenaufträge erfüllt!",
    production: "Auftragsmenge",
    orders: "Aufträge",
    ok : "Bestätigen Sie Ihre Lieferantenbestellungen",
    okProduction: "Bestätigen Sie den Fertigungsbeginn"
  },

  stats: {
    suppliersRemains: "Lieferantenrückstand",
    buffers: "Puffer",
    resume: "Zusammenfassung",
    orders: "Aufträge",
    stock: "Bestand",
    remains: "Fehlmenge",
    cost: "Kosten",
    stockDelay: "Bestand & Fehlmengen",
    companies: "Knoten",
    red: "Rote Zone",
    yellow: "Gelbe Zone",
    green: "Grüne Zone",
    flowEquation: "Net Flow"
  },

  dd: {
    cmj: "Mittlerer Tagesverbrauch",
    leadTime: "Nachversorgungszeit",
    variabilityFactor: "Schwankungsfaktor",
    delayFactor: "Nachversorgungszeitfaktor",
    availableStock: "Lagerbestand",
    clientsRemains: "Qualifizierter Bedarf",
    suppliersRemains: "Nachversorgungsaufträge",
    AverageStockLevelTarget: "Mittleres Bestandsziel",
    falseOrder: "Sie haben nicht die richtige Menge bestellt",
    applyAutoCmj: "Automatische Anwendung des berechneten mittleren Tagesverbrauchs",
    calculatedCMJ: "Berechneter mittlerer Tagesverbrauch"
  },

  debrief: {
    resume: {
      name: "Name",
      level: "Platz",
      resume: "Zusammenfassung",
      averageOrderQuantity: "Mittlerer Lieferantenbedarf",
      averageRequestQuantity: "Mittlerer Kundenbedarf",
      range: "Bedarfsbereich",
      otd: "Pünktliche Lieferung",
      delaysDepth: "Verspätungen in Wochen",
      averageStock: "Mittlerer Bestand",
      stockCost: "Bestandskosten",
      delayCost: "Fehlmengenkosten",
      cost: "Gesamtkosten",
    }
  },

  user : {
    noParties : 'Kein Spiel mit diesem Code und Konto vorhanden',
    falseTrainningKey : 'Falscher Trainerschlüssel',
    welcome : "Willkommen zum Spiel ",
    noMorePlace : "In diesem Spiel gibt es keinen freien Platz mehr",
    notOpen: "Das Spiel ist eröffnet",
    logoutConfirmation: "Sind Sie sicher, dass Sie das Spiele verlassen wollen?",
    sessionExpired: "Ihre Sitzung ist abgelaufen, bitte melden Sie sich erneut an"
  },

  store : {
    error : "Error : "
  }
}